export const MEMBERS_READ = "members.read";
export const MEMBERS_WRITE = "members.write";
/** The club's own lists: statuses, charge categories, billing arrangements, minimum plans, custom fields. */
export const MEMBERS_MANAGE = "members.manage";
/** Billing permissions, for the statement history on the household page. */
export const BILLING_READ = "billing.read";
export const BILLING_CLOSE = "billing.close";
